"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressBalanceResponseToJSON = exports.AddressBalanceResponseFromJSONTyped = exports.AddressBalanceResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AddressBalanceResponseFromJSON(json) {
    return AddressBalanceResponseFromJSONTyped(json, false);
}
exports.AddressBalanceResponseFromJSON = AddressBalanceResponseFromJSON;
function AddressBalanceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'stx': _1.AddressBalanceResponseStxFromJSON(json['stx']),
        'fungible_tokens': json['fungible_tokens'],
        'non_fungible_tokens': json['non_fungible_tokens'],
        'token_offering_locked': !runtime_1.exists(json, 'token_offering_locked') ? undefined : _1.AddressTokenOfferingLockedFromJSON(json['token_offering_locked']),
    };
}
exports.AddressBalanceResponseFromJSONTyped = AddressBalanceResponseFromJSONTyped;
function AddressBalanceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'stx': _1.AddressBalanceResponseStxToJSON(value.stx),
        'fungible_tokens': value.fungible_tokens,
        'non_fungible_tokens': value.non_fungible_tokens,
        'token_offering_locked': _1.AddressTokenOfferingLockedToJSON(value.token_offering_locked),
    };
}
exports.AddressBalanceResponseToJSON = AddressBalanceResponseToJSON;
//# sourceMappingURL=AddressBalanceResponse.js.map